import type { BookedAncillaryDTO } from '@/types/dto/agent';

// TEMPORARY: due to mapping in backend, fees are currently returned under admissions
// override them on UI side for MaaS project.
const MAAS_FEE_NAME_OVERRIDES: Record<string, { en: string; et: string }> = {
  'FEE_TYPE.SALES_FEE': { en: 'Sales fee', et: 'Teenustasu' },
  'FEE_TYPE.RETURN_SERVICE_FEE': { en: 'Refund fee', et: 'Tagastustasu' },
};

export const getMaasFeeAncillaryName = (
  ancillary: Pick<BookedAncillaryDTO, 'type'>,
  language: string
): string | undefined => {
  const override = ancillary.type
    ? MAAS_FEE_NAME_OVERRIDES[ancillary.type]
    : undefined;

  if (!override) {
    return undefined;
  }

  return language.startsWith('et') ? override.et : override.en;
};
